const letters = [
    {latin: 'a', cyrillic: 'а'},
    {latin: 'b', cyrillic: 'б'},
    {latin: 'v', cyrillic: 'в'},
    {latin: 'g', cyrillic: 'г'},
    {latin: 'd', cyrillic: 'д'},
    {latin: ']', cyrillic: 'ѓ'},
    {latin: 'e', cyrillic: 'е'},
    {latin: '\\', cyrillic: 'ж'},
    {latin: 'z', cyrillic: 'з'},
    {latin: 'y', cyrillic: 'ѕ'},
    {latin: 'i', cyrillic: 'и'},
    {latin: 'j', cyrillic: 'ј'},
    {latin: 'k', cyrillic: 'к'},
    {latin: 'l', cyrillic: 'л'},
    {latin: 'q', cyrillic: 'љ'},
    {latin: 'm', cyrillic: 'м'},
    {latin: 'n', cyrillic: 'н'},
    {latin: 'w', cyrillic: 'њ'},
    {latin: 'o', cyrillic: 'о'},
    {latin: 'p', cyrillic: 'п'},
    {latin: 'r', cyrillic: 'р'},
    {latin: 's', cyrillic: 'с'},
    {latin: 't', cyrillic: 'т'},
    {latin: '\'', cyrillic: 'ќ'},
    {latin: 'u', cyrillic: 'у'},
    {latin: 'f', cyrillic: 'ф'},
    {latin: 'h', cyrillic: 'х'},
    {latin: 'c', cyrillic: 'ц'},
    {latin: ';', cyrillic: 'ч'},
    {latin: 'x', cyrillic: 'џ'},
    {latin: '[', cyrillic: 'ш'}
]

String.prototype.transcript = function (lang) {
    let isLatin = true
    for (let i = 0; i < this.length; i++) {
        if (!letters.find(l => l.latin === this[i].toLowerCase())) {
            isLatin = false
            break;
        }
    }

    let newValue = ""

    if (lang === "mk_MK" && isLatin) {
        for (let i = 0; i < this.length; i++) {
            newValue += letters.find(l => l.latin === this[i].toLowerCase()).cyrillic
        }
        return newValue
    } else if(lang !== "mk_MK" && !isLatin) {
        for (let i = 0; i < this.length; i++) {
            newValue += letters.find(l => l.cyrillic === this[i].toLowerCase()).latin
        }
        return newValue
    }

    return this
}